
import { Box, Grid } from "@mui/material";
import { useState, useEffect } from "react";
import API from '../../api';
import SettingsCard from './options-components/switchSettings';
import ProfileOptions from './options-components/ProfileOptions';
import { boxStyle } from '../../theme';
import Header from "../../components/Header";
import OptionsAutorizations from "./options-components/optionsAutorizations";
import TelegramId from "./options-components/telegramID";
import LicenseList from "./options-components/LicenseList";
import DevicesList from "./options-components/DevicesList";
import AddLecsCard from "./options-components/addLecs";
import { useLocation } from "react-router-dom";

const UserOptions = () => {
  const [userResponse, setUserResponse] = useState({})
  const [settings] = useState('user')
  const [addLecs, setAddLecs] = useState(sessionStorage.getItem('selectedTab') === 'Add Lecs' ? true : false)
  const [, setDeviceResponse] = useState({})
  const [ToViewAccountAutorization] = useState(false)
  const [user, setUser] = useState('')
  const [selectedSetting, setSelectedSetting] = useState('profile');
  const [licenses, setLicenses] = useState([]);
  const [devices, setDevices] = useState([]);
  const location = useLocation();

  useEffect(() => {
    API.getUserOptions({})
      .then((response) => {
        setUserResponse(response.data);
      })
      .catch((error) => {
        console.error("[UserOptions] Errore nel recupero dei dati del dispositivo:", error);
      });

    API.getDeviceOptions().then(res => {
      setDeviceResponse(res.data[0])
    })

    API.getLicenses({}).then((res) => {
      setLicenses(res.data);
    }).catch((err) => {
      setLicenses([]);
    })

    API.getAllLecsOptions({}).then((res) => {
      setDevices(res.data);
    }).catch((err) => {
      setDevices([]);
    })
  }, [settings, addLecs, ToViewAccountAutorization, user]);

  useEffect(() => {
    if(settings === 'user'){
      setAddLecs(false);
      setUser('');
    }
  }, [settings])

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const firstKey = [...params.keys()][0];

    if (firstKey) {
      setSelectedSetting(firstKey);
    }
  }, [location.search]);

  return (
    <Box m={"20px"}>
      <Header title={"Account Options"} />
      <Grid container spacing={2} mt={2}>
        <Grid size={3}>
          <SettingsCard selected={selectedSetting} setSelected={setSelectedSetting}/>
        </Grid>
        <Grid size={9}>
          <Box sx={{...boxStyle, height: 550}}>
            {selectedSetting === "profile" ? (
              <ProfileOptions userData={userResponse}/>
            ) : selectedSetting === "account_auth" ? (
              <OptionsAutorizations mainUser={userResponse}/>
            ) : selectedSetting === "licenses" ? (
              <LicenseList licenses={licenses} setLicenses={setLicenses}/>
            ) : selectedSetting === "devices" ? (
              <DevicesList devices={devices} setDevices={setDevices} />
            ) : selectedSetting === "add_lecs" ? (
              <AddLecsCard licenses={licenses} />
            ) : selectedSetting === "telegram" ? (
              <TelegramId item={userResponse}/>
            ) : (
              null
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserOptions;